import { GridSortItem } from "@mui/x-data-grid";
import { createSlice, current, PayloadAction } from "@reduxjs/toolkit";
import { PointsOfSaleFilters } from "Interfaces/PointsOfSaleFilters";

export interface IPointOfSaleState {
  searchText: string;
  pageIndex: number;
  pageNumber: number;
  pageSize: number;
  total: number;
  sort: GridSortItem[];
  filters: PointsOfSaleFilters;

}

const initialState: IPointOfSaleState = {
  searchText: "",
  pageIndex: 0,
  pageNumber: 0,
  pageSize: 10,
  total: 0,
  sort: [
    {
      field: "name",
      sort: "asc",
    },
  ],
  filters: {},
};

export const pointOfSaleSlice = createSlice({
  initialState,
  name: "pointOfSaleSlice",
  reducers: {
    setSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload;
    },
    setPageIndex: (state, action: PayloadAction<number>) => {
      state.pageIndex = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setTotal: (state, action: PayloadAction<number>) => {
      state.total = action.payload;
    },
    setSort: (state, action: PayloadAction<GridSortItem[]>) => {
      state.sort = action.payload;
    },
    updateFilters: (state, action: PayloadAction<PointsOfSaleFilters>) => {
      state.filters = action.payload;
    },
    removeCurrentFilters: (state, action: PayloadAction<string>) => {
      let filtersWithRemovedCode: PointsOfSaleFilters = {
        ...current(state).filters,
      };
      delete filtersWithRemovedCode[action.payload as keyof PointsOfSaleFilters];
      state.filters = filtersWithRemovedCode;
    },
  },
});

export default pointOfSaleSlice.reducer;

export const {
  setSearchText,
  setPageIndex,
  setPageSize,
  setTotal,
  setSort,
  updateFilters,
  removeCurrentFilters
} = pointOfSaleSlice.actions;
